import React, { memo } from 'react';

import VerifyEmailSuccess from '@/pages/VerifyEmailSuccess';

const VerifyEmailUsed = () => <VerifyEmailSuccess />;

export default memo(VerifyEmailUsed);
